<template>
  <div class="tw-h-full">
    <div
      class="tw-h-[50px] tw-w-full tw-relative tw-z-10 tw-bg-white tw-border-b tw-border-solid tw-border-gray-200 tw-flex tw-items-center tw-justify-between tw-px-4">
      <h2 class="tw-font-semibold tw-text-lg">{{ $t('pages.dashboard.overview') }}</h2>
      <div>
        <a-button @click="show.filters = !show.filters" intent="simple" class="tw-py-0 !tw-min-h-[30px] "
          left-icon="lucide:list-filter">
          <span>{{ $t('buttons.filter') }}</span>
        </a-button>
      </div>
    </div>

    <div :class="[show.filters ? 'tw-grid-rows-[1fr]' : 'tw-grid-rows-[0fr]']"
      class="tw-grid tw-duration-300 tw-transition-all">
      <div class="tw-overflow-hidden tw-col-span-1">
        <div
          class="tw-h-[200px] tw-bg-white tw-w-full -tw-translate-y-1 tw-border-b tw-border-solid tw-border-gray-200">
        </div>
      </div>
    </div>


    <div class="tw-p-2 tw-grid tw-grid-cols-12 tw-gap-2">
      <div class="tw-col-span-12">
        <AgentPerformanceWidget />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-4">
        <DailyDroppedOrdersChart />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-4">
        <DailyTreatedOrdersChart />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-4">
        <DailyConfirmedOrdersChart />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-4">
        <ConfirmationChart />
      </div>
      <div class="tw-col-span-12 md:tw-col-span-4">
        <TopProductsWidget />
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, provide } from 'vue';
import AgentPerformanceWidget from '@/components/dashboard/agent/AgentPerformanceWidget.vue';
import DailyTreatedOrdersChart from '@/components/dashboard/agent/charts/DailyTreatedOrdersChart.vue';
import DailyConfirmedOrdersChart from '@/components/dashboard/agent/charts/DailyConfirmedOrdersChart.vue';
import DailyDroppedOrdersChart from '@/components/dashboard/agent/charts/DailyDroppedOrdersChart.vue';
import ConfirmationChart from '@/components/dashboard/agent/charts/ConfirmationChart.vue';
import TopProductsWidget from '@/components/dashboard/agent/TopProductsWidget.vue';
import { useAuthStore } from '@/stores';


const authStore = useAuthStore();
const show = ref({ filters: false });
const filters = ref({ agent_id: [ authStore.user.id ] });


provide('filters', filters);
provide('register', () => null);

</script>

<style></style>
